import React from "react";

const GROUP_ORDER = ["Account", "Workspace"];

export default function SettingsNav({ sections, active, onSelect }) {
  const groups = GROUP_ORDER
    .map((g) => ({ group: g, items: sections.filter((s) => s.group === g) }))
    .filter((g) => g.items.length > 0);

  return (
    <>
      {/* Mobile: dropdown (below lg) */}
      <div className="lg:hidden">
        <select
          value={active}
          onChange={(e) => onSelect(e.target.value)}
          data-testid="settings-nav-select"
          className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          {groups.map((g) => (
            <optgroup key={g.group} label={g.group}>
              {g.items.map((s) => (
                <option key={s.key} value={s.key}>{s.label}</option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      {/* Desktop: vertical rail (lg+) */}
      <nav className="hidden lg:block w-56 shrink-0" data-testid="settings-nav">
        <div className="space-y-6 sticky top-6">
          {groups.map((g) => (
            <div key={g.group}>
              <div className="px-3 mb-1.5 text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold">
                {g.group}
              </div>
              <div className="space-y-0.5">
                {g.items.map((s) => {
                  const Icon = s.icon;
                  const isActive = s.key === active;
                  return (
                    <button
                      key={s.key}
                      type="button"
                      onClick={() => onSelect(s.key)}
                      data-testid={`settings-nav-${s.key}`}
                      className={`w-full flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors ${
                        isActive
                          ? "bg-slate-100 text-slate-900 font-medium"
                          : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                      }`}
                    >
                      <Icon size={18} weight="regular" className={isActive ? "text-blue-600" : "text-slate-400"} />
                      {s.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </nav>
    </>
  );
}
